import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "form-group courseContentItem" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "ms-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pushContent && _ctx.pushContent(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Aggiungi nuovo contenuto",
          text: "Aggiungi nuovo contenuto"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contents, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-sm-3 mt-3",
          key: i
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-danger",
                onClick: ($event: any) => (_ctx.removeContent(i))
              }, " x ", 8, _hoisted_5)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-primary",
                onClick: ($event: any) => (_ctx.moveSx(i))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Sposta a sx",
                  text: "Sposta a sx"
                })
              ], 8, _hoisted_7),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-sm btn-primary",
                onClick: ($event: any) => (_ctx.moveDx(i))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Sposta a dx",
                  text: "Sposta a dx"
                })
              ], 8, _hoisted_8)
            ]),
            _createElementVNode("label", null, _toDisplayString(i + 1) + ". " + _toDisplayString(item.title), 1),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: ($event: any) => (_ctx.openContentModal(item))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Apri gestione video",
                  text: "Apri gestione video"
                })
              ], 8, _hoisted_9)
            ]),
            _createElementVNode("div", null, [
              (item.url)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Video caricato",
                      text: "Video caricato"
                    }),
                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fa fa-check text-success" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}